module.exports = __webpack_public_path__ + "static/studio-06-f4a09a1dfee52580d97088529a40bb82.webp";